import React, { useState, useEffect } from "react";
import {
  Collapse,
  Card,
  Form,
  Row,
  Col,
  DatePicker,
  Radio,
  Button,
  Spin,
  message,
  Select,
} from "antd";
import { errHandler } from "../../helper/helper";
import CustomFooter from "../../Layout/CustomFooter";
import "./Audit.css";
import {
  generateTransactionsBalancesAuditReport,
  generateCustomerRegistrationAuditReport,
  getAllBranches,
  getAllDistrict,
  getAllBranchesByDistrictName,
  getAllDepositsProducts,
  generateGroupDepositAuditReport,
  getDistrictDivisionalBranchDetails,
  getAllLoans,
  generateLoanValueIssuedAuditReport,
  generateLoanApplicationAuditReport,
  generateFixedDepositAnalysisAuditReport,
  generateLoanDisbursementSummaryReport,
  generateCompulsoryBalanceAccountReport,
} from "./AuditService";
import generateTransactionBalanceAuditExcel from "../../Utils/TransactionBalanceAuditExcel";
import generateCustomerRegistrationAuditExcel from "../../Utils/CustomerRegAuditExcel";
import generateGroupDepositAuditExcel from "../../Utils/GroupDepositAuditExcel";
import generateLoanValueIssuedAuditExcel from "../../Utils/LoanValueIssuedAuditExcel";
import generateLoanApplicationAuditExcel from "../../Utils/LoanApplicationAuditExcel";
import { generateFixedDepositAnalysisAuditExcel } from '../../Utils/FixedDepositAnalysisExcel';



import generateCompulsoryBalanceAccountExcel from "../../Utils/CompulsoryBalanceAccountExcel";

import jwt_decode from "jwt-decode";
import dayjs from "dayjs";
import LoanAmountWiseDispose from "./LoanAmountWiseDispose";
import PermissionPanel from "../../Layout/PermissionPanel";

const { Panel } = Collapse;
const { RangePicker } = DatePicker;
const { Option } = Select;

const Audit = () => {
  const [dateOption, setDateOption] = useState("range");
  const [selectedDates, setSelectedDates] = useState(null);
  const [selectedMonths, setSelectedMonths] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [loading, setLoading] = useState(false);

  const [branches, setBranches] = useState([]);
  const [selectedBranchIds, setSelectedBranchIds] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [selectedDistricts, setSelectedDistricts] = useState(null);

  const [custRegEndDate, setCustRegEndDate] = useState(null);
  const [custRegBranchIds, setCustRegBranchIds] = useState([]);
  const [custRegLoading, setCustRegLoading] = useState(false);

  const [depositsProducts, setDepositsProducts] = useState([]);
  const [selectedDepositProduct, setSelectedDepositProduct] = useState(null);
  const [districtDivisionalBranchData, setDistrictDivisionalBranchData] = useState([]);
  const [loanProducts, setLoanProducts] = useState([]);

  const [transBalanceFilters, setTransBalanceFilters] = useState({
    districts: [],
    divisionalAreas: [],
    branches: [],
  });
  const [transBalanceAvailableBranches, setTransBalanceAvailableBranches] = useState([]);
  const [transBalanceAvailableDivisionalAreas, setTransBalanceAvailableDivisionalAreas] = useState([]);

  const [custRegFilters, setCustRegFilters] = useState({
    districts: [],
    divisionalAreas: [],
    branches: [],
  });
  const [custRegAvailableBranches, setCustRegAvailableBranches] = useState([]);
  const [custRegAvailableDivisionalAreas, setCustRegAvailableDivisionalAreas] = useState([]);

  const [groupDepositFilters, setGroupDepositFilters] = useState({
    districts: [],
    divisionalAreas: [],
    branches: [],
  });
  const [groupDepositAvailableBranches, setGroupDepositAvailableBranches] = useState([]);
  const [groupDepositAvailableDivisionalAreas, setGroupDepositAvailableDivisionalAreas] = useState([]);
  const [groupDepositProduct, setGroupDepositProduct] = useState(null);
  const [groupDepositDate, setGroupDepositDate] = useState(null);
  const [groupDepositLoading, setGroupDepositLoading] = useState(false);
  const [groupDepositBranchIds, setGroupDepositBranchIds] = useState([]);

  const [loanValueFilters, setLoanValueFilters] = useState({
    districts: [],
    divisionalAreas: [],
    branches: [],
  });
  const [loanValueAvailableBranches, setLoanValueAvailableBranches] = useState([]);
  const [loanValueAvailableDivisionalAreas, setLoanValueAvailableDivisionalAreas] = useState([]);
  const [loanValueProduct, setLoanValueProduct] = useState(null);
  const [loanValueMonthRange, setLoanValueMonthRange] = useState(null);
  const [loanValueLoading, setLoanValueLoading] = useState(false);

  // New Compulsory Balance Account Analysis states
  const [compulsoryBalanceBranchIds, setCompulsoryBalanceBranchIds] = useState([]);
  const [compulsoryBalanceDate, setCompulsoryBalanceDate] = useState(null);
  const [compulsoryBalanceLoading, setCompulsoryBalanceLoading] = useState(false);

  const [LoanApplicationFilters, setLoanApplicationFilters] = useState({
    districts: [],
    divisionalAreas: [],
    branches: [],
  });
  const [loanAppAvailableBranches, setLoanAppAvailableBranches] = useState([]);
  const [loanAppAvailableDivisionalAreas, setLoanAppAvailableDivisionalAreas] = useState([]);
  const [loanAppEndDate, setLoanAppEndDate] = useState(null);
  const [loanAppLoading, setLoanAppLoading] = useState(false);

  const [fixedDepositFilters, setFixedDepositFilters] = useState({
    districts: [],
    divisionalAreas: [],
    branches: [],
  });
  const [fixedDepositAvailableBranches, setFixedDepositAvailableBranches] = useState([]);
  const [fixedDepositAvailableDivisionalAreas, setFixedDepositAvailableDivisionalAreas] = useState([]);
  const [fixedDepositLoading, setFixedDepositLoading] = useState(false);


  const token = localStorage.getItem("accessToken");
  const decodeToken = token ? jwt_decode(token) : null;
  const loginPlaceId = localStorage.getItem("placeId");
  const districtName = loginPlaceId === "4" ? decodeToken?.districtName : null;

  useEffect(() => {
    getAllBranches()
      .then((res) => setBranches(res?.data || []))
      .catch(() => message.error("Failed to load branches"));

    getAllDistrict()
      .then((res) => setDistricts(res?.data || []))
      .catch(() => message.error("Failed to load districts"));

    getAllDepositsProducts()
      .then((res) => setDepositsProducts(res?.data || []))
      .catch(() => message.error("Failed to load products"));

    getAllDistrictDivisionalBranch();
    getLoans();
  }, []);

  const getLoans = () => {
    getAllLoans()
      .then((res) => {
        let data = res.data;
        setLoanProducts(data);
      })
      .catch((err) => {
        errHandler(err);
      });
  };

  const getAllDistrictDivisionalBranch = () => {
    getDistrictDivisionalBranchDetails()
      .then((res) => {
        setDistrictDivisionalBranchData(res.data);
      })
      .catch((err) => {
        errHandler(err);
      });
  };

  const handleDistrictsChange = (value) => {
    setSelectedDistricts(value);
    setSelectedBranchIds([]);
    setCustRegBranchIds([]);
    setGroupDepositBranchIds([]);
    // setLoanValueBranchIds([]);
    setCompulsoryBalanceBranchIds([]);

    getAllBranchesByDistrictName(value)
      .then((res) => setBranches(res?.data || []))
      .catch((err) => errHandler(err));
  };

  useEffect(() => {
    const filteredDivisionalAreas = districtDivisionalBranchData
      .filter(d => transBalanceFilters.districts.includes(d.districtId))
      .flatMap(d => d.divisionalAreaDtoList || []);

    setTransBalanceFilters(prev => ({
      ...prev,
      divisionalAreas: prev.divisionalAreas.filter(did =>
        filteredDivisionalAreas.some(d => d.divAId === did)
      )
    }));

    setTransBalanceAvailableDivisionalAreas(filteredDivisionalAreas);
  }, [transBalanceFilters.districts, districtDivisionalBranchData]);

  useEffect(() => {
    const filteredBranches = districtDivisionalBranchData
      .flatMap(d => d.divisionalAreaDtoList || [])
      .filter(div => transBalanceFilters.divisionalAreas.includes(div.divAId))
      .flatMap(div => div.branchDtoList || []);

    setTransBalanceAvailableBranches(filteredBranches);

    setTransBalanceFilters(prev => ({
      ...prev,
      branches: prev.branches.filter(bid =>
        filteredBranches.some(b => b.id === bid)
      )
    }));
  }, [transBalanceFilters.divisionalAreas, districtDivisionalBranchData]);

  useEffect(() => {
    const filteredDivisionalAreas = districtDivisionalBranchData
      .filter(d => custRegFilters.districts.includes(d.districtId))
      .flatMap(d => d.divisionalAreaDtoList || []);

    setCustRegFilters(prev => ({
      ...prev,
      divisionalAreas: prev.divisionalAreas.filter(did =>
        filteredDivisionalAreas.some(d => d.divAId === did)
      )
    }));

    setCustRegAvailableDivisionalAreas(filteredDivisionalAreas);
  }, [custRegFilters.districts, districtDivisionalBranchData]);

  useEffect(() => {
    const filteredBranches = districtDivisionalBranchData
      .flatMap(d => d.divisionalAreaDtoList || [])
      .filter(div => custRegFilters.divisionalAreas.includes(div.divAId))
      .flatMap(div => div.branchDtoList || []);

    setCustRegAvailableBranches(filteredBranches);

    setCustRegFilters(prev => ({
      ...prev,
      branches: prev.branches.filter(bid =>
        filteredBranches.some(b => b.id === bid)
      )
    }));
  }, [custRegFilters.divisionalAreas, districtDivisionalBranchData]);

  useEffect(() => {
    const filteredDivisionalAreas = districtDivisionalBranchData
      .filter(d => groupDepositFilters.districts.includes(d.districtId))
      .flatMap(d => d.divisionalAreaDtoList || []);

    setGroupDepositFilters(prev => ({
      ...prev,
      divisionalAreas: prev.divisionalAreas.filter(did =>
        filteredDivisionalAreas.some(d => d.divAId === did)
      )
    }));

    setGroupDepositAvailableDivisionalAreas(filteredDivisionalAreas);
  }, [groupDepositFilters.districts, districtDivisionalBranchData]);

  useEffect(() => {
    const filteredBranches = districtDivisionalBranchData
      .flatMap(d => d.divisionalAreaDtoList || [])
      .filter(div => groupDepositFilters.divisionalAreas.includes(div.divAId))
      .flatMap(div => div.branchDtoList || []);

    setGroupDepositAvailableBranches(filteredBranches);

    setGroupDepositFilters(prev => ({
      ...prev,
      branches: prev.branches.filter(bid =>
        filteredBranches.some(b => b.id === bid)
      )
    }));
  }, [groupDepositFilters.divisionalAreas, districtDivisionalBranchData]);

  useEffect(() => {
    const filteredDivisionalAreas = districtDivisionalBranchData
      .filter(d => loanValueFilters.districts.includes(d.districtId))
      .flatMap(d => d.divisionalAreaDtoList || []);

    setLoanValueFilters(prev => ({
      ...prev,
      divisionalAreas: prev.divisionalAreas.filter(did =>
        filteredDivisionalAreas.some(d => d.divAId === did)
      )
    }));

    setLoanValueAvailableDivisionalAreas(filteredDivisionalAreas);
  }, [loanValueFilters.districts, districtDivisionalBranchData]);

  useEffect(() => {
    const filteredBranches = districtDivisionalBranchData
      .flatMap(d => d.divisionalAreaDtoList || [])
      .filter(div => loanValueFilters.divisionalAreas.includes(div.divAId))
      .flatMap(div => div.branchDtoList || []);

    setLoanValueAvailableBranches(filteredBranches);

    setLoanValueFilters(prev => ({
      ...prev,
      branches: prev.branches.filter(bid =>
        filteredBranches.some(b => b.id === bid)
      )
    }));
  }, [loanValueFilters.divisionalAreas, districtDivisionalBranchData]);

  useEffect(() => {
    const filteredBranches = districtDivisionalBranchData
      .flatMap(d => d.divisionalAreaDtoList || [])
      .filter(div => LoanApplicationFilters.divisionalAreas.includes(div.divAId))
      .flatMap(div => div.branchDtoList || []);

    setLoanApplicationFilters(prev => ({
      ...prev,
      branches: prev.branches.filter(bid =>
        filteredBranches.some(b => b.id === bid)
      )
    }));

    setLoanAppAvailableBranches(filteredBranches);
  }, [LoanApplicationFilters.divisionalAreas, districtDivisionalBranchData]);


  useEffect(() => {
    const filteredDivisionalAreas = districtDivisionalBranchData
      .filter(d => LoanApplicationFilters.districts.includes(d.districtId))
      .flatMap(d => d.divisionalAreaDtoList || []);

    setLoanApplicationFilters(prev => ({
      ...prev,
      divisionalAreas: prev.divisionalAreas.filter(did =>
        filteredDivisionalAreas.some(d => d.divAId === did)
      )
    }));

    setLoanAppAvailableDivisionalAreas(filteredDivisionalAreas);
  }, [LoanApplicationFilters.districts, districtDivisionalBranchData]);

  useEffect(() => {
    const filteredDivisionalAreas = districtDivisionalBranchData
      .filter(d => fixedDepositFilters.districts.includes(d.districtId))
      .flatMap(d => d.divisionalAreaDtoList || []);

    setFixedDepositFilters(prev => ({
      ...prev,
      divisionalAreas: prev.divisionalAreas.filter(did =>
        filteredDivisionalAreas.some(d => d.divAId === did)
      )
    }));

    setFixedDepositAvailableDivisionalAreas(filteredDivisionalAreas);
  }, [fixedDepositFilters.districts, districtDivisionalBranchData]);

  useEffect(() => {
    const filteredBranches = districtDivisionalBranchData
      .flatMap(d => d.divisionalAreaDtoList || [])
      .filter(div => fixedDepositFilters.divisionalAreas.includes(div.divAId))
      .flatMap(div => div.branchDtoList || []);

    setFixedDepositAvailableBranches(filteredBranches);

    setFixedDepositFilters(prev => ({
      ...prev,
      branches: prev.branches.filter(bid =>
        filteredBranches.some(b => b.id === bid)
      )
    }));
  }, [fixedDepositFilters.divisionalAreas, districtDivisionalBranchData]);





  const handleBranchSelectAll = (value, setter, branches, currentSelection) => {
    if (value.includes("all")) {
      const allBranchIds = branches.map((b) => b.id);
      if (currentSelection.length === branches.length) {
        setter([]);
      } else {
        setter(allBranchIds);
      }
    } else {
      setter(value);
    }
  };

  // Load compulsory products
  const generateCompulsoryBalanceReport = () => {
    if (!compulsoryBalanceBranchIds.length) {
      message.error("Please select at least one branch");
      return;
    }
    if (!compulsoryBalanceDate) {
      message.error("Please select an audit date");
      return;
    }

    const data = {
      selectedDate: compulsoryBalanceDate.format("YYYY-MM-DD"),
      branchIdList: compulsoryBalanceBranchIds,
    };

    console.log("Sending request with branches:", compulsoryBalanceBranchIds);
    console.log("Selected branches from state:", branches.filter(branch => compulsoryBalanceBranchIds.includes(branch.id)));

    setCompulsoryBalanceLoading(true);
    generateCompulsoryBalanceAccountReport(data)
      .then((res) => {
        const reportData = res?.data || res;
        console.log("Received data from backend:", reportData);

        if (!reportData || reportData.length === 0) {
          message.warning("No data found for the selected criteria");
          return;
        }

        // Log which branches actually returned data
        const returnedBranchIds = reportData.map(item => item.branchId);
        console.log("Branches with data:", returnedBranchIds);

        const selectedBranchNames = branches
          .filter(branch => compulsoryBalanceBranchIds.includes(branch.id))
          .map(branch => branch.branchName);

        console.log("All selected branch names:", selectedBranchNames);

        generateCompulsoryBalanceAccountExcel(
          reportData,
          selectedBranchNames,
          compulsoryBalanceDate.format("YYYY-MM-DD")
        );

        message.success(`Report generated with data from ${reportData.length} branches`);
      })
      .catch((err) => {
        console.error("Error generating report:", err);
        errHandler(err);
      })
      .finally(() => setCompulsoryBalanceLoading(false));
  };

  const generateAuditReport = () => {
    let startDate, endDate;
    if (dateOption === "range") {
      [startDate, endDate] = selectedDates || [];
    } else if (dateOption === "month") {
      const [startMonth, endMonth] = selectedMonths || [];
      startDate = dayjs(startMonth).startOf("month");
      endDate = dayjs(endMonth).endOf("month");
    }

    if (!transBalanceFilters.branches.length) {
      errHandler("Please select at least one branch before generating report");
      return;
    }
    if (!startDate || !endDate) {
      errHandler("Please select a valid date range");
      return;
    }
    if (!selectedDepositProduct) {
      errHandler("Please select a deposit product");
      return;
    }

    const data = {
      selectedDate: startDate.format("YYYY-MM-DD"),
      endDate: endDate.format("YYYY-MM-DD"),
      branchIdList: transBalanceFilters.branches,
      productId: selectedDepositProduct,
    };

    setLoading(true);
    generateTransactionsBalancesAuditReport(data)
      .then((res) => {
        const reportData = res?.data || res;
        if (!reportData) throw new Error("No data from server");
        generateTransactionBalanceAuditExcel(reportData);
      })
      .catch((err) => errHandler(err))
      .finally(() => setLoading(false));
  };

  const generateCustomerRegAudit = () => {
    if (!custRegFilters.branches.length) {
      errHandler("Please select at least one branch before generating report");
      return;
    }
    if (!custRegEndDate) {
      errHandler("Please select an end date");
      return;
    }

    const data = {
      endDate: custRegEndDate.format("YYYY-MM-DD"),
      branchIdList: custRegFilters.branches,
    };

    setCustRegLoading(true);
    generateCustomerRegistrationAuditReport(data)
      .then((res) => {
        const reportData = res?.data || res;
        if (!reportData) throw new Error("No data from server");
        generateCustomerRegistrationAuditExcel(reportData, custRegEndDate.format("YYYY-MM-DD"));
      })
      .catch((err) => errHandler(err))
      .finally(() => setCustRegLoading(false));
  };

  const generateGroupDepositAudit = () => {
    if (!groupDepositFilters.branches.length) {
      errHandler("Please select at least one branch");
      return;
    }
    if (!groupDepositProduct) {
      errHandler("Please select a deposit product");
      return;
    }
    if (!groupDepositDate) {
      errHandler("Please select a date");
      return;
    }

    const data = {
      productId: 5, //only group deposit
      endDate: groupDepositDate.format("YYYY-MM-DD"),
      branchIdList: groupDepositFilters.branches,
    };

    setGroupDepositLoading(true);
    generateGroupDepositAuditReport(data)
      .then((res) => {
        const reportData = res?.data || res;
        if (!reportData) throw new Error("No data from server");
        generateGroupDepositAuditExcel(reportData);
      })
      .catch((err) => errHandler(err))
      .finally(() => setGroupDepositLoading(false));
  };

  const generateLoanValueReport = () => {
    if (!loanValueFilters.branches.length) {
      errHandler("Please select at least one branch");
      return;
    }
    if (!loanValueProduct) {
      errHandler("Please select a loan product");
      return;
    }
    if (!loanValueMonthRange) {
      errHandler("Please select month range");
      return;
    }

    const [startMonth, endMonth] = loanValueMonthRange;
    const data = {
      selectedDate: dayjs(startMonth).startOf("month").format("YYYY-MM-DD"),
      endDate: dayjs(endMonth).endOf("month").format("YYYY-MM-DD"),
      branchIdList: loanValueFilters.branches,
      productIdList: loanValueProduct,
    };

    setLoanValueLoading(true);
    generateLoanValueIssuedAuditReport(data)
      .then((res) => {
        const reportData = res?.data || res;
        if (!reportData) throw new Error("No data from server");
        generateLoanValueIssuedAuditExcel(reportData);
      })
      .catch((err) => errHandler(err))
      .finally(() => setLoanValueLoading(false));
  };

  const generateLoanApplicationReport = () => {
    let startDate, endDate;

    if (dateOption === "range") {
      [startDate, endDate] = selectedDates || [];
    } else if (dateOption === "month") {
      const [startMonth, endMonth] = selectedMonths || [];
      startDate = dayjs(startMonth).startOf("month");
      endDate = dayjs(endMonth).endOf("month");
    }

    if (!LoanApplicationFilters.branches.length) {
      errHandler("Please select at least one branch before generating report");
      return;
    }

    if (!startDate || !endDate) {
      errHandler("Please select a valid date range");
      return;
    }

    const data = {
      selectedDate: startDate.format("YYYY-MM-DD"),
      endDate: endDate.format("YYYY-MM-DD"),
      branchIdList: LoanApplicationFilters.branches
    };

    setLoanAppLoading(true);

    generateLoanApplicationAuditReport(data)
      .then((res) => {
        const reportData = res?.data || res;
        if (!reportData) throw new Error("No data from server");

        generateLoanApplicationAuditExcel(
          reportData,
          data.selectedDate,
          data.endDate
        );
      })
      .catch((err) => errHandler(err))
      .finally(() => setLoanAppLoading(false));
  };

  const generateFixedDepositAnalysisReport = async () => {
    if (!fixedDepositFilters.branches.length) {
      errHandler("Please select at least one branch before generating report");
      return;
    }

    if (!endDate) {
      errHandler("Please select a valid end date");
      return;
    }

    const formattedEndDate = endDate.format("YYYY-MM-DD");

    const data = {
      endDate: formattedEndDate,
      branchIdList: fixedDepositFilters.branches,
      districtIdList: fixedDepositFilters.districts,
      divAIdList: fixedDepositFilters.divisionalAreas,
    };

    try {
      setFixedDepositLoading(true);
      const res = await generateFixedDepositAnalysisAuditReport(data);

      const reportData = res?.data || res;
      if (!reportData || !reportData.length) {
        throw new Error("No data from server");
      }

      await generateFixedDepositAnalysisAuditExcel(
        reportData,
        null,
        formattedEndDate
      );
    } catch (err) {
      errHandler(err.message || err);
    } finally {
      setFixedDepositLoading(false);
    }
  };


  return (
    <>
      <div>
        <h3>Audit</h3>
      </div>

      <Collapse className="collapse-report ">
        <PermissionPanel
          permission="transactionBalanceAuditReport"
          placeIds={["3"]}
          header="Transaction Balance Audit Report"
          key="transactionBalanceAuditReport" className="collapse-panel">
          <div className="panel-container">
            <Card hoverable className="inner-card">
              <Form layout="vertical">
                <Row gutter={[16, 16]} justify="space-around">
                  {loginPlaceId === "3" && (
                    <Col span={24}>
                      <Form.Item label="Select Districts">
                        <Select
                          mode="multiple"
                          placeholder="Select districts"
                          style={{ width: '100%' }}
                          value={transBalanceFilters.districts}
                          onChange={value =>
                            setTransBalanceFilters(prev => ({ ...prev, districts: value }))
                          }
                        >
                          {districtDivisionalBranchData.map(d => (
                            <Option key={d.districtId} value={d.districtId}>
                              🏙️ {d.districtName}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                  )}

                  {loginPlaceId === "3" && (
                    <Col span={24}>
                      <Form.Item label="Select Divisional Areas">
                        <Select
                          mode="multiple"
                          placeholder="Select divisional areas"
                          style={{ width: '100%' }}
                          value={transBalanceFilters.divisionalAreas}
                          onChange={(values) => {
                            if (values.includes("ALL")) {
                              setTransBalanceFilters(prev => ({
                                ...prev,
                                divisionalAreas: transBalanceAvailableDivisionalAreas.map(d => d.divAId)
                              }));
                            } else {
                              setTransBalanceFilters(prev => ({ ...prev, divisionalAreas: values }));
                            }
                          }}
                        >
                          <Option key="ALL" value="ALL">
                            🔘 Select All Divisional Areas
                          </Option>
                          {transBalanceAvailableDivisionalAreas.map(d => (
                            <Option key={d.divAId} value={d.divAId}>
                              🏙️ {d.divAIdName}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                  )}

                  {loginPlaceId === "3" && (
                    <Col span={24}>
                      <Form.Item label="Select Branch(es)">
                        <Select
                          mode="multiple"
                          placeholder="Select branches"
                          style={{ width: '100%' }}
                          value={transBalanceFilters.branches}
                          onChange={(values) => {
                            if (values.includes('ALL')) {
                              setTransBalanceFilters(prev => ({
                                ...prev,
                                branches: transBalanceAvailableBranches.map(b => b.id)
                              }));
                            } else {
                              setTransBalanceFilters(prev => ({ ...prev, branches: values }));
                            }
                          }}
                          disabled={transBalanceAvailableBranches.length === 0}
                        >
                          <Option key="ALL" value="ALL">
                            🔘 Select All Branches
                          </Option>
                          {transBalanceAvailableBranches.map(branch => (
                            <Option key={branch.id} value={branch.id}>
                              🏢 {branch.branchName}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                  )}

                  <Col span={24}>
                    <Form.Item label="Deposit Product">
                      <Select
                        value={selectedDepositProduct}
                        onChange={(value) => setSelectedDepositProduct(value)}
                        style={{ width: "100%" }}
                        placeholder="Select a product"
                      >
                        {depositsProducts?.map((product) => (
                          <Option key={product.productId} value={product.productId}>
                            {product.productCode} - {product.productName}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item label="Select Report Type">
                      <Radio.Group onChange={(e) => setDateOption(e.target.value)} value={dateOption}>
                        <Radio value="range">Date Range</Radio>
                        <Radio value="month">Monthly Range</Radio>
                      </Radio.Group>
                    </Form.Item>
                  </Col>
                  {dateOption === "range" && (
                    <Col span={24}>
                      <Form.Item label="Date Range">
                        <RangePicker style={{ width: "100%" }} onChange={setSelectedDates} />
                      </Form.Item>
                    </Col>
                  )}
                  {dateOption === "month" && (
                    <Col span={24}>
                      <Form.Item label="Select Month Range">
                        <RangePicker picker="month" style={{ width: "100%" }} onChange={setSelectedMonths} />
                      </Form.Item>
                    </Col>
                  )}
                  <Col span={24} style={{ textAlign: "right" }}>
                    <Form.Item className="generate-btn-outline">
                      <Button
                        className="generate-btn"
                        onClick={generateAuditReport}
                        disabled={
                          (dateOption === "range" && !selectedDates) ||
                          (dateOption === "month" && !selectedMonths)
                        }
                      >
                        {loading ? <Spin /> : "Generate Report"}
                      </Button>
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
            </Card>
          </div>
        </PermissionPanel>

        {/* Customer Registration Audit */}
        <PermissionPanel
          permission="customerRegistrationAuditReport"
          placeIds={["3"]}
          header="Customer Registration Audit Report"
          key="customerRegistrationAuditReport" className="collapse-panel">
          <div className="panel-container">
            <Card hoverable className="inner-card">
              <Form layout="vertical">
                <Row gutter={[16, 16]} justify="space-around">
                  {loginPlaceId === "3" && (
                    <Col span={24}>
                      <Form.Item label="Select Districts">
                        <Select
                          mode="multiple"
                          placeholder="Select districts"
                          style={{ width: '100%' }}
                          value={custRegFilters.districts}
                          onChange={value =>
                            setCustRegFilters(prev => ({ ...prev, districts: value }))
                          }
                        >
                          {districtDivisionalBranchData.map(d => (
                            <Option key={d.districtId} value={d.districtId}>
                              🏙️ {d.districtName}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                  )}

                  {loginPlaceId === "3" && (
                    <Col span={24}>
                      <Form.Item label="Select Divisional Areas">
                        <Select
                          mode="multiple"
                          placeholder="Select divisional areas"
                          style={{ width: '100%' }}
                          value={custRegFilters.divisionalAreas}
                          onChange={(values) => {
                            if (values.includes("ALL")) {
                              setCustRegFilters(prev => ({
                                ...prev,
                                divisionalAreas: custRegAvailableDivisionalAreas.map(d => d.divAId)
                              }));
                            } else {
                              setCustRegFilters(prev => ({ ...prev, divisionalAreas: values }));
                            }
                          }}
                        >
                          <Option key="ALL" value="ALL">
                            🔘 Select All Divisional Areas
                          </Option>
                          {custRegAvailableDivisionalAreas.map(d => (
                            <Option key={d.divAId} value={d.divAId}>
                              🏙️ {d.divAIdName}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                  )}

                  {loginPlaceId === "3" && (
                    <Col span={24}>
                      <Form.Item label="Select Branch(es)">
                        <Select
                          mode="multiple"
                          placeholder="Select branches"
                          style={{ width: '100%' }}
                          value={custRegFilters.branches}
                          onChange={(values) => {
                            if (values.includes('ALL')) {
                              setCustRegFilters(prev => ({
                                ...prev,
                                branches: custRegAvailableBranches.map(b => b.id)
                              }));
                            } else {
                              setCustRegFilters(prev => ({ ...prev, branches: values }));
                            }
                          }}
                          disabled={custRegAvailableBranches.length === 0}
                        >
                          <Option key="ALL" value="ALL">
                            🔘 Select All Branches
                          </Option>
                          {custRegAvailableBranches.map(branch => (
                            <Option key={branch.id} value={branch.id}>
                              🏢 {branch.branchName}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                  )}

                  <Col span={24}>
                    <Form.Item label="Select Date">
                      <DatePicker style={{ width: "100%" }} onChange={setCustRegEndDate} />
                    </Form.Item>
                  </Col>
                  <Col span={24} style={{ textAlign: "right" }}>
                    <Form.Item className="generate-btn-outline">
                      <Button
                        className="generate-btn"
                        onClick={generateCustomerRegAudit}
                        disabled={!custRegEndDate}
                      >
                        {custRegLoading ? <Spin /> : "Generate Report"}
                      </Button>
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
            </Card>
          </div>
        </PermissionPanel>

        <PermissionPanel
          permission="loanDisposeAuditReport"
          placeIds={["3"]}
          header="Loan amount wise dispose summary"
          key="loanDisposeAuditReport"
          className="collapse-panel">
          <LoanAmountWiseDispose
            loginPlaceId={loginPlaceId}
            districtData={districtDivisionalBranchData}
            products={loanProducts}
          />
        </PermissionPanel>

        <PermissionPanel
          permission="groupDepositAuditReport"
          placeIds={["3"]}
          header="Group Deposit Audit Report"
          key="groupDepositAuditReport"
          className="collapse-panel">
          <div className="panel-container">
            <Card hoverable className="inner-card">
              <Form layout="vertical">
                <Row gutter={[16, 16]} justify="space-around">
                  {loginPlaceId === "3" && (
                    <Col span={24}>
                      <Form.Item label="Select Districts">
                        <Select
                          mode="multiple"
                          placeholder="Select districts"
                          style={{ width: '100%' }}
                          value={groupDepositFilters.districts}
                          onChange={value =>
                            setGroupDepositFilters(prev => ({ ...prev, districts: value }))
                          }
                        >
                          {districtDivisionalBranchData.map(d => (
                            <Option key={d.districtId} value={d.districtId}>
                              🏙️ {d.districtName}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                  )}

                  {loginPlaceId === "3" && (
                    <Col span={24}>
                      <Form.Item label="Select Divisional Areas">
                        <Select
                          mode="multiple"
                          placeholder="Select divisional areas"
                          style={{ width: '100%' }}
                          value={groupDepositFilters.divisionalAreas}
                          onChange={(values) => {
                            if (values.includes("ALL")) {
                              setGroupDepositFilters(prev => ({
                                ...prev,
                                divisionalAreas: groupDepositAvailableDivisionalAreas.map(d => d.divAId)
                              }));
                            } else {
                              setGroupDepositFilters(prev => ({ ...prev, divisionalAreas: values }));
                            }
                          }}
                        >
                          <Option key="ALL" value="ALL">
                            🔘 Select All Divisional Areas
                          </Option>
                          {groupDepositAvailableDivisionalAreas.map(d => (
                            <Option key={d.divAId} value={d.divAId}>
                              🏙️ {d.divAIdName}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                  )}

                  {loginPlaceId === "3" && (
                    <Col span={24}>
                      <Form.Item label="Select Branch(es)">
                        <Select
                          mode="multiple"
                          placeholder="Select branches"
                          style={{ width: '100%' }}
                          value={groupDepositFilters.branches}
                          onChange={(values) => {
                            if (values.includes('ALL')) {
                              setGroupDepositFilters(prev => ({
                                ...prev,
                                branches: groupDepositAvailableBranches.map(b => b.id)
                              }));
                            } else {
                              setGroupDepositFilters(prev => ({ ...prev, branches: values }));
                            }
                          }}
                          disabled={groupDepositAvailableBranches.length === 0}
                        >
                          <Option key="ALL" value="ALL">
                            🔘 Select All Branches
                          </Option>
                          {groupDepositAvailableBranches.map(branch => (
                            <Option key={branch.id} value={branch.id}>
                              🏢 {branch.branchName}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                  )}
                  <Col span={24}>
                    <Form.Item label="Select Audit Date">
                      <DatePicker style={{ width: "100%" }} onChange={setGroupDepositDate} />
                    </Form.Item>
                  </Col>
                  <Col span={24} style={{ textAlign: "right" }}>
                    <Form.Item className="generate-btn-outline">
                      <Button
                        className="generate-btn"
                        onClick={generateGroupDepositAudit}
                        disabled={!groupDepositProduct || !groupDepositDate || !groupDepositFilters.branches.length}
                      >
                        {groupDepositLoading ? <Spin /> : "Generate Report"}
                      </Button>
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
            </Card>
          </div>
        </PermissionPanel>


        <PermissionPanel
          permission="loanValueIssuedAuditReport"
          placeIds={["3"]}
          header="Loan Value Issued (Balance) Report"
          key="loanValueIssuedAuditReport"
          className="collapse-panel">
          <div className="panel-container">
            <Card hoverable className="inner-card">
              <Form layout="vertical">
                <Row gutter={[16, 16]} justify="space-around">
                  {loginPlaceId === "3" && (
                    <Col span={24}>
                      <Form.Item label="Select Districts">
                        <Select
                          mode="multiple"
                          placeholder="Select districts"
                          style={{ width: '100%' }}
                          value={loanValueFilters.districts}
                          onChange={value =>
                            setLoanValueFilters(prev => ({ ...prev, districts: value }))
                          }
                        >
                          {districtDivisionalBranchData.map(d => (
                            <Option key={d.districtId} value={d.districtId}>
                              🏙️ {d.districtName}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                  )}

                  {loginPlaceId === "3" && (
                    <Col span={24}>
                      <Form.Item label="Select Divisional Areas">
                        <Select
                          mode="multiple"
                          placeholder="Select divisional areas"
                          style={{ width: '100%' }}
                          value={loanValueFilters.divisionalAreas}
                          onChange={(values) => {
                            if (values.includes("ALL")) {
                              setLoanValueFilters(prev => ({
                                ...prev,
                                divisionalAreas: loanValueAvailableDivisionalAreas.map(d => d.divAId)
                              }));
                            } else {
                              setLoanValueFilters(prev => ({ ...prev, divisionalAreas: values }));
                            }
                          }}
                        >
                          <Option key="ALL" value="ALL">
                            🔘 Select All Divisional Areas
                          </Option>
                          {loanValueAvailableDivisionalAreas.map(d => (
                            <Option key={d.divAId} value={d.divAId}>
                              🏙️ {d.divAIdName}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                  )}

                  {loginPlaceId === "3" && (
                    <Col span={24}>
                      <Form.Item label="Select Branch(es)">
                        <Select
                          mode="multiple"
                          placeholder="Select branches"
                          style={{ width: '100%' }}
                          value={loanValueFilters.branches}
                          onChange={(values) => {
                            if (values.includes('ALL')) {
                              setLoanValueFilters(prev => ({
                                ...prev,
                                branches: loanValueAvailableBranches.map(b => b.id)
                              }));
                            } else {
                              setLoanValueFilters(prev => ({ ...prev, branches: values }));
                            }
                          }}
                          disabled={loanValueAvailableBranches.length === 0}
                        >
                          <Option key="ALL" value="ALL">
                            🔘 Select All Branches
                          </Option>
                          {loanValueAvailableBranches.map(branch => (
                            <Option key={branch.id} value={branch.id}>
                              🏢 {branch.branchName}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                  )}

                  <Col span={24}>
                    <Form.Item label="Select Loan Product">
                      <Select
                        mode="multiple"
                        value={loanValueProduct}
                        onChange={setLoanValueProduct}
                        style={{ width: "100%" }}
                        placeholder="Select loan products"
                      >
                        {loanProducts?.map((product) => (
                          <Option key={product.productId} value={product.productId}>
                            {product.productCode} - {product.productName}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>


                  <Col span={24}>
                    <Form.Item label="Select Month Range">
                      <RangePicker picker="month" style={{ width: "100%" }} onChange={setLoanValueMonthRange} />
                    </Form.Item>
                  </Col>

                  <Col span={24} style={{ textAlign: "right" }}>
                    <Form.Item className="generate-btn-outline">
                      <Button
                        className="generate-btn"
                        onClick={generateLoanValueReport}
                        disabled={!loanValueProduct || !loanValueMonthRange || !loanValueFilters.branches.length}
                      >
                        {loanValueLoading ? <Spin /> : "Generate Report"}
                      </Button>
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
            </Card>
          </div>
        </PermissionPanel>

        {/* Compulsory Balance Account Analysis - Updated panel */}
        <PermissionPanel
          permission="compulsoryBalanceAccountAnalysisReport"
          placeIds={["3"]}
          header="Compulsory Balance Account Analysis"
          key="compulsoryBalanceAccountAnalysisReport"
          className="collapse-panel"
        >
          <div className="panel-container">
            <Card hoverable className="inner-card">
              <Form layout="vertical">
                <Row gutter={[16, 16]} justify="space-around">
                  <Col span={24}>
                    <Form.Item label="Select District">
                      <Select
                        value={selectedDistricts}
                        onChange={handleDistrictsChange}
                        style={{ width: "100%" }}
                        placeholder="Select district"
                      >
                        {districts?.map((district) => (
                          <Option key={district.districtId} value={district.districtName}>
                            {district.districtName}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>

                  <Col span={24}>
                    <Form.Item label="Select Branch">
                      <Select
                        mode="multiple"
                        value={compulsoryBalanceBranchIds}
                        onChange={(value) =>
                          handleBranchSelectAll(value, setCompulsoryBalanceBranchIds, branches, compulsoryBalanceBranchIds)
                        }
                        style={{ width: "100%" }}
                        placeholder="Select branches"
                      >
                        <Option key="all" value="all">
                          {compulsoryBalanceBranchIds.length === branches.length ? "Unselect All" : "Select All"}
                        </Option>
                        {branches?.map((branch) => (
                          <Option key={branch.id} value={branch.id}>
                            {branch.branchName}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>

                  <Col span={24}>
                    <Form.Item
                      label="Select Audit Date"
                      required
                      rules={[{ required: true, message: 'Please select audit date' }]}
                    >
                      <DatePicker
                        style={{ width: "100%" }}
                        onChange={setCompulsoryBalanceDate}
                        format="YYYY-MM-DD"
                        placeholder="Select audit date"
                        disabledDate={(current) => current && current > dayjs().endOf('day')}
                      />
                    </Form.Item>
                  </Col>

                  <Col span={24} style={{ textAlign: "right" }}>
                    <Form.Item className="generate-btn-outline">
                      <Button
                        className="generate-btn"
                        onClick={generateCompulsoryBalanceReport}
                        disabled={!compulsoryBalanceDate || !compulsoryBalanceBranchIds.length}
                        type="primary"
                        size="large"
                      >
                        {compulsoryBalanceLoading ? <Spin size="small" /> : "Generate Report"}
                      </Button>
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
            </Card>
          </div>
        </PermissionPanel>
        <PermissionPanel
          permission="loanApplicationAuditReport"
          placeIds={["3"]} header="Loan Application Report"
          key="loanApplicationAuditReport"
          className="collapse-panel">
          <div className="panel-container">
            <Card hoverable className="inner-card">
              <Form layout="vertical">
                <Row gutter={[16, 16]} justify="space-around">

                  {loginPlaceId === "3" && (
                    <Col span={24}>
                      <Form.Item label="Select Districts">
                        <Select
                          mode="multiple"
                          placeholder="Select districts"
                          style={{ width: '100%' }}
                          value={LoanApplicationFilters.districts}
                          onChange={value =>
                            setLoanApplicationFilters(prev => ({ ...prev, districts: value }))
                          }
                        >
                          {districtDivisionalBranchData.map(d => (
                            <Option key={d.districtId} value={d.districtId}>
                              🏙️ {d.districtName}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                  )}

                  {loginPlaceId === "3" && (
                    <Col span={24}>
                      <Form.Item label="Select Divisional Areas">
                        <Select
                          mode="multiple"
                          placeholder="Select divisional areas"
                          style={{ width: '100%' }}
                          value={LoanApplicationFilters.divisionalAreas}
                          onChange={values => {
                            if (values.includes("ALL")) {
                              setLoanApplicationFilters(prev => ({
                                ...prev,
                                divisionalAreas: loanAppAvailableDivisionalAreas.map(d => d.divAId)
                              }));
                            } else {
                              setLoanApplicationFilters(prev => ({ ...prev, divisionalAreas: values }));
                            }
                          }}
                        >
                          <Option key="ALL" value="ALL">
                            🔘 Select All Divisional Areas
                          </Option>
                          {loanAppAvailableDivisionalAreas.map(d => (
                            <Option key={d.divAId} value={d.divAId}>
                              🏙️ {d.divAIdName}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                  )}

                  {loginPlaceId === "3" && (
                    <Col span={24}>
                      <Form.Item label="Select Branch(es)">
                        <Select
                          mode="multiple"
                          placeholder="Select branches"
                          style={{ width: '100%' }}
                          value={LoanApplicationFilters.branches}
                          onChange={values => {
                            if (values.includes("ALL")) {
                              setLoanApplicationFilters(prev => ({
                                ...prev,
                                branches: loanAppAvailableBranches.map(b => b.id)
                              }));
                            } else {
                              setLoanApplicationFilters(prev => ({ ...prev, branches: values }));
                            }
                          }}
                          disabled={loanAppAvailableBranches.length === 0}
                        >
                          <Option key="ALL" value="ALL">
                            🔘 Select All Branches
                          </Option>
                          {loanAppAvailableBranches.map(branch => (
                            <Option key={branch.id} value={branch.id}>
                              🏢 {branch.branchName}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                  )}

                  <Col span={24}>
                    <Form.Item label="Select Report Type">
                      <Radio.Group onChange={(e) => setDateOption(e.target.value)} value={dateOption}>
                        <Radio value="range">Date Range</Radio>
                        <Radio value="month">Monthly Range</Radio>
                      </Radio.Group>
                    </Form.Item>
                  </Col>

                  {dateOption === "range" && (
                    <Col span={24}>
                      <Form.Item label="Date Range">
                        <RangePicker style={{ width: "100%" }} onChange={setSelectedDates} />
                      </Form.Item>
                    </Col>
                  )}

                  {dateOption === "month" && (
                    <Col span={24}>
                      <Form.Item label="Select Month Range">
                        <RangePicker picker="month" style={{ width: "100%" }} onChange={setSelectedMonths} />
                      </Form.Item>
                    </Col>
                  )}

                  <Col span={24} style={{ textAlign: "right" }}>
                    <Form.Item className="generate-btn-outline">
                      <Button
                        className="generate-btn"
                        onClick={generateLoanApplicationReport}
                        disabled={
                          (dateOption === "range" && !selectedDates) ||
                          (dateOption === "month" && !selectedMonths)
                        }
                      >
                        {loanAppLoading ? <Spin /> : "Generate Report"}
                      </Button>
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
            </Card>
          </div>
        </PermissionPanel>

        <PermissionPanel
          permission="fixDepositAccountAuditReport"
          placeIds={["3"]}
          header="Fixed Deposit Account Analysis Report"
          key="fixDepositAccountAuditReport"
          className="collapse-panel">
          <div className="panel-container">
            <Card hoverable className="inner-card">
              <Form layout="vertical">
                <Row gutter={[16, 16]} justify="space-around">

                  {loginPlaceId === "3" && (
                    <Col span={24}>
                      <Form.Item label="Select Districts">
                        <Select
                          mode="multiple"
                          placeholder="Select districts"
                          style={{ width: '100%' }}
                          value={fixedDepositFilters.districts}
                          onChange={value =>
                            setFixedDepositFilters(prev => ({ ...prev, districts: value }))
                          }
                        >
                          {districtDivisionalBranchData.map(d => (
                            <Option key={d.districtId} value={d.districtId}>
                              🏙️ {d.districtName}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                  )}

                  {loginPlaceId === "3" && (
                    <Col span={24}>
                      <Form.Item label="Select Divisional Areas">
                        <Select
                          mode="multiple"
                          placeholder="Select divisional areas"
                          style={{ width: '100%' }}
                          value={fixedDepositFilters.divisionalAreas}
                          onChange={values => {
                            if (values.includes("ALL")) {
                              setFixedDepositFilters(prev => ({
                                ...prev,
                                divisionalAreas: fixedDepositAvailableDivisionalAreas.map(d => d.divAId)
                              }));
                            } else {
                              setFixedDepositFilters(prev => ({ ...prev, divisionalAreas: values }));
                            }
                          }}
                        >
                          <Option key="ALL" value="ALL">
                            🔘 Select All Divisional Areas
                          </Option>
                          {fixedDepositAvailableDivisionalAreas.map(d => (
                            <Option key={d.divAId} value={d.divAId}>
                              🏙️ {d.divAIdName}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                  )}

                  {loginPlaceId === "3" && (
                    <Col span={24}>
                      <Form.Item label="Select Branch(es)">
                        <Select
                          mode="multiple"
                          placeholder="Select branches"
                          style={{ width: '100%' }}
                          value={fixedDepositFilters.branches}
                          onChange={values => {
                            if (values.includes("ALL")) {
                              setFixedDepositFilters(prev => ({
                                ...prev,
                                branches: fixedDepositAvailableBranches.map(b => b.id)
                              }));
                            } else {
                              setFixedDepositFilters(prev => ({ ...prev, branches: values }));
                            }
                          }}
                          disabled={fixedDepositAvailableBranches.length === 0}
                        >
                          <Option key="ALL" value="ALL">
                            🔘 Select All Branches
                          </Option>
                          {fixedDepositAvailableBranches.map(branch => (
                            <Option key={branch.id} value={branch.id}>
                              🏢 {branch.branchName}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                  )}

                  <Col span={24}>
                    <Form.Item label="Select End Date">
                      <DatePicker
                        style={{ width: '100%' }}
                        value={endDate}
                        onChange={date => setEndDate(date)}
                      />
                    </Form.Item>
                  </Col>

                  <Col span={24} style={{ textAlign: "right" }}>
                    <Form.Item className="generate-btn-outline">
                      <Button
                        className="generate-btn"
                        onClick={generateFixedDepositAnalysisReport}
                        disabled={!endDate}
                      >
                        {fixedDepositLoading ? <Spin /> : "Generate Report"}
                      </Button>
                    </Form.Item>
                  </Col>

                </Row>
              </Form>
            </Card>
          </div>
        </PermissionPanel>

      </Collapse >

      <CustomFooter />
    </>
  );
};

export default Audit;
